import React, { useState } from "react";
import Scrollbar from "../../../components/Scrollbar";
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  Button,
  TablePagination,
} from "@mui/material";
import MovimientosHeader from "../../../components/TableHeader/MovimientosHeader";
import { LISTAR_BANCOS } from "../../../graphql/bancos";
import { useQuery } from "@apollo/client";
import Iconify from "../../../components/Iconify";
import FrmEditarBanco from "./Forms/FrmEditarBanco";
import { useNavigate } from "react-router-dom";
import BancosMovimientos from "../../../pages/BancosMovimientos";
const TABLE_HEAD = [
  {
    id: "banco",
    label: "Banco",
    alignRight: false,
  },
  {
    id: "nocuenta",
    label: "No. de Cuenta",
    alignRight: false,
  },
  {
    id: "clabe",
    label: "No de Cuenta CLABE",
    alignRight: false,
  },
  {
    id: "saldo",
    label: "Saldo",
    alignRight: false,
  },
  {
    id: "",
    label: "",
    alignRight: false,
  },
];
const BancoTabla = ({
  setOpenDialog,
  setBodyDialog,
  setErrorGraph,
  setOpenSnackBar,
}) => {
  const { data, loading, error } = useQuery(LISTAR_BANCOS);
  const [page, setPage] = useState(0);
  const navigate = useNavigate();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  if (loading) {
    return <h1>Obteniendo información...</h1>;
  }
  const { obtenerListaBancos } = data;
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleDetalleBancario = async (id) => {
    try {
      navigate(`/dashboard/bancos/detalle/${id}`, {
        replace: true,
        element: <BancosMovimientos idBanco={id} />,
      });
    } catch (error) {
      console.log(error);
    }
  };

  //Edicion
  const handleEditData = (e) => {
    setBodyDialog(
      <FrmEditarBanco
        setOpenDialog={setOpenDialog}
        setErrorGraph={setErrorGraph}
        setOpenSnackBar={setOpenSnackBar}
        id={e}
      />
    );
    setOpenDialog(true);
  };
  return (
    <>
      <Scrollbar>
        <Table>
          <MovimientosHeader headLabel={TABLE_HEAD} />
          <TableBody>
            {obtenerListaBancos
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                const { id, banco, nocuenta, clabe, montoapertura } = row;
                return (
                  <TableRow hover key={id} tabIndex={-1}>
                    <TableCell>{banco}</TableCell>
                    <TableCell>{nocuenta}</TableCell>
                    <TableCell>{clabe}</TableCell>
                    <TableCell>
                      $ {montoapertura == 0 ? "1" : montoapertura }
                    </TableCell>
                    <TableCell>
                      <Button
                        value={id}
                        onClick={(e) => {
                          handleEditData(id);
                        }}
                        startIcon={<Iconify icon="eva:edit-2-outline" />}
                      >
                        Editar
                      </Button>
                      <Button onClick={() => handleDetalleBancario(id)}>
                        Movimientos
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </Scrollbar>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        page={page}
        count={obtenerListaBancos.length}
        rowsPerPage={rowsPerPage}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
};

export default BancoTabla;
